export default import.meta.ROLLUP_FILE_URL_Bfe9A5yJ;